import GrinningFace from "@assets/wordpuzzle/grinning-face-with-big-eyes.svg";
import Group from "@assets/wordpuzzle/Group.svg";
import ThinkingFace from "@assets/wordpuzzle/thinking-face.svg";

type StatusMessageProps = {
  result: string;
  incorrectCombination: string;
};

function StatusMessage({
  result,
  incorrectCombination,
}: StatusMessageProps): JSX.Element {
  return (
    <>
      {result === "correct" && (
        <div className="flex items-center shadow-lg justify-center flex-row  w-full md:h-14 bg-bg-primary">
          <img
            src={GrinningFace}
            className="w-12 h-12 p-2"
            alt="Status Correct"
          />
          <span className="text-sm text-green-500">Betul!</span>
        </div>
      )}
      {result === "correctNext" && (
        <div className="flex items-center shadow-lg justify-center flex-row  w-full md:h-14 bg-bg-primary">
          <img src={Group} className="p-2 w-12 h-12" alt="Status CorrectNext" />
          <span className="text-sm text-green-500 font-primary">
            Pilih perkataan yang betul
          </span>
        </div>
      )}
      {result === "incorrect" && (
        <div className="flex items-center shadow-lg justify-center flex-row  w-full md:h-14 bg-bg-primary">
          <img
            src={ThinkingFace}
            className="w-12 h-12 p-2"
            alt="Status Incorrect"
          />
          <span className="text-sm">Salah!</span>
          <span className="pl-2 text-sm text-gray-700">
            {incorrectCombination}
          </span>
        </div>
      )}
    </>
  );
}

export default StatusMessage;
